import React from 'react';
import { isIconifyIcon, iconifyUrl } from '../utils/iconUtil';
import '../css/IconGlyph.css';

/**
 * Draws a saved icon value: an emoji as text, or an Iconify id as a CSS mask
 * over `currentColor`, so it takes the colour of whatever it sits in (a dark
 * pill gets a light icon) and no fetched SVG markup is ever injected.
 *
 * @param {object} props
 * @param {string} [props.icon] - emoji or Iconify id; nothing renders when empty
 * @param {string} [props.className] - sizing class from the caller
 * @returns {JSX.Element|null}
 */
function IconGlyph({ icon, className = '' }) {
  if (!icon) return null;

  if (isIconifyIcon(icon)) {
    const url = `url(${iconifyUrl(icon)})`;
    return (
      <span
        className={`icon-glyph icon-glyph-mask ${className}`.trim()}
        style={{ WebkitMaskImage: url, maskImage: url }}
        aria-hidden="true"
      />
    );
  }

  return <span className={`icon-glyph icon-glyph-emoji ${className}`.trim()} aria-hidden="true">{icon}</span>;
}

export default IconGlyph;
